/**
 * Google Analytics 4 (GA4).
 * El tag puede estar en index.html (gtag ya definido) o cargarse por REACT_APP_GA_MEASUREMENT_ID.
 * En SPA enviamos page_view manualmente en cada cambio de ruta.
 */

const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function isGAEnabled() {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') return true;
  return typeof MEASUREMENT_ID === 'string' && MEASUREMENT_ID.trim().length > 0;
}

/**
 * Inicializa GA4 por env (solo si el tag no está ya en index.html).
 * Inyecta gtag y hace config con send_page_view: false.
 */
export function initGA() {
  if (typeof window !== 'undefined' && window.gtag) return;
  if (!MEASUREMENT_ID || !MEASUREMENT_ID.trim()) return;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', MEASUREMENT_ID.trim(), { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID.trim()}`;
  document.head.appendChild(script);
}

/**
 * Envía un page_view a GA4 (para usar en cada cambio de ruta en la SPA).
 * @param {string} path - page_path (pathname + search), ej. "/noticias/peliculas/mi-post"
 * @param {string} [title] - Opcional: título de la página para el informe
 */
export function sendPageView(path, title) {
  if (!isGAEnabled() || typeof window.gtag !== 'function') return;
  const payload = { page_path: path || '/' };
  if (title) payload.page_title = title;
  window.gtag('event', 'page_view', payload);
}
